import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Image from 'react-bootstrap/Image';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import AppMenu from './AppMenu';
import { useSelector, useDispatch } from "react-redux";
import { clearUser } from "../../store/slices/userSlice";
import { fetchBusinessMembers, clearBusinessMembers } from '../../store/slices/businessSlice';
import { APP_VERSION_LABEL } from '../../constants/version';

const AppHeader = ({ menuOpen, handleStateChange }) => {
  const location = useLocation();
  const [accountOpen, setAccountOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBusinessMembers());
  }, []);
  const isBusinessManager = useSelector(state => state.businessMembers.isBusinessManager);
  const isEdcAdmin = useSelector(state => state.businessMembers.isEdcAdmin);
  const isAdmin = useSelector(state => state.user.isAdmin);

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  }));

  const accountToggle = async () => {
    setAccountOpen(!accountOpen);

    // 當帳號下拉展開時，重新檢查權限
    if (!accountOpen) {
      dispatch(fetchBusinessMembers());
    }
  };

  const userName = localStorage.getItem('user_name') || '';
  const displayInitial = userName.charAt(0).toUpperCase();

  const handleLogout = () => {
    localStorage.clear();
    dispatch(clearUser());
    dispatch(clearBusinessMembers());
    window.location.href = '/';
  };

  const handleMenuOpen = () => {
    handleStateChange({ isOpen: !menuOpen });
  };

  const prevMenuOpenRef = useRef(menuOpen);

  useEffect(() => {
    if (!prevMenuOpenRef.current && menuOpen) {
      dispatch(fetchBusinessMembers());
    }

    prevMenuOpenRef.current = menuOpen;
  }, [menuOpen, dispatch]);


  return (
    <React.Fragment>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar variant="dense" className="AppLoginHeader">
          <div className="nav-area">
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleMenuOpen}
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>

            <Link to="/HomePage" className="logo ms-4">
              <Image
                alt="Cloudgoda"
                src="/assets/images/logo_light_navbar_v1.2@2x.png"
                rounded
                style={{ width: '100px', height: 'auto' }}
              />
            </Link>
            <AppMenu menuOpen={menuOpen} handleStateChange={handleStateChange} />
          </div>
          <div className="setting-area">
            <Dropdown isOpen={accountOpen} toggle={accountToggle}>
              <DropdownToggle tag="span" className="user-circle">
                {displayInitial}
              </DropdownToggle>
              <DropdownMenu className="user-dropdown">
                <DropdownItem>
                  <Link to="/user" className="dropdown-link">
                    帳戶管理
                  </Link>
                </DropdownItem>
                {(isBusinessManager || isEdcAdmin || isAdmin) && (
                  <DropdownItem>
                    <Link to="/admin-management" className="dropdown-link">
                      管理員設定
                    </Link>
                  </DropdownItem>
                )}
                <DropdownItem onClick={handleLogout} className="dropdown-link">
                  登出
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem disabled className="small">
                  版本 {APP_VERSION_LABEL}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

export default AppHeader;
